import React, { useState } from 'react';
import { Avatar, Drawer, FloatButton } from 'antd';
import { CloseOutlined, CommentOutlined } from '@ant-design/icons';
import Copilot from './Copilot';
import AIFloatButton from './AIButton';

interface GlobalCopilotProps {
  copilotOpen: boolean;
  setCopilotOpen: (open: boolean) => void;
}

const GlobalCopilot: React.FC<GlobalCopilotProps> = ({
    copilotOpen,
    setCopilotOpen,
  }) => {
  //const [copilotOpen, setCopilotOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleFullscreenChange = (fullscreen: boolean) => {
    setIsFullscreen(fullscreen);
  };

  return (
    <>
      {/* 右下角悬浮按钮 */}
      {!copilotOpen && (
        <AIFloatButton
          onClick={() => setCopilotOpen(true)}
        />
      )}

      <Drawer
        title={null}
        placement="right"
        width={isFullscreen ? '100vw' : 550}
        closable={false}
        maskClosable={false}
        onClose={ ()=> setCopilotOpen(false)}
        open={copilotOpen}
        styles={{
          body: { padding: 0, display: 'flex', flexDirection: 'column', },
          mask: { pointerEvents: 'none', background: 'transparent'}
        }}
        rootStyle={isFullscreen ? {
            top: 106,
            height: '100vh',
            left: 0,
            right: 0
          } : {
            top: 180,           // 距离页面顶部
            height: 'calc(100% - 150px)', // 高度减少
          }
        }
      >
          <Copilot 
            copilotOpen={copilotOpen} 
            setCopilotOpen={setCopilotOpen}
            onFullscreenChange={handleFullscreenChange}  // 传递全屏回调
          />
      </Drawer>
      {/* 聊天对话框 */}
      {/* <div style={{
        position: 'fixed',
        right: copilotOpen ? 24 : -624, // 关闭时隐藏在屏幕外
        bottom: 24,
        width: 600,
        height: 800,
        zIndex: 1001,
        boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
        borderRadius: 12,
        overflow: 'hidden',
        transition: 'right 0.3s ease-in-out',
        background: '#fff'
      }}>
        <Copilot copilotOpen={copilotOpen} setCopilotOpen={setCopilotOpen} />
      </div> */}
    </>
  );
};

export default GlobalCopilot;